import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { clientUrls } from "misc/urls";
import { CheckAppPermissions } from "misc/authentication";

import DrillDownDashboard from "../components/DrillDownDashboard";
import ZsplDashboard from "../components/ZsplDashboard";

const ZsplContainer = () => {
    return (
        <CheckAppPermissions allowed={["permission_zspl"]} fallback={<Redirect to={clientUrls.modules.vlv.baseUrl()} />}>
            <Switch>
                <Route exact path={clientUrls.zspl.depot()} component={DrillDownDashboard} />
                <Route exact path={clientUrls.zspl.dashboard()} component={ZsplDashboard} />
                <Redirect to={clientUrls.zspl.dashboard()} />
            </Switch>
        </CheckAppPermissions>
    );
};

export default ZsplContainer;
